import React from 'react';

import {colors} from '../../colors/colors';
import {LoadingText} from '../../loading-placeholder/loading-text';

export type ColumnWidths = {
    name: number;
    sku: number;
    quantity: number;
    price: number;
    term: number;
    discount: number;
    total: number;
};

export const COLUMN_WIDTHS: ColumnWidths = {
    name: 298, // width with all columns visible
    sku: 100,
    quantity: 85,
    price: 110,
    term: 90,
    discount: 110,
    total: 110,
};

// Column widths for small screens
export const COLUMN_WIDTHS_RESPONSIVE: ColumnWidths = {
    name: 200, // width with all columns visible
    sku: 85,
    quantity: 85,
    price: 75,
    term: 90,
    discount: 110,
    total: 80,
};

export const TEMPLATE_COLUMN_WIDTHS: ColumnWidths = {
    name: 280, // width with all columns visible
    sku: 80,
    quantity: 85,
    price: 85,
    term: 110,
    discount: 120,
    total: 85,
};

export const FIELD_NAMES = {
    name: 'name',
    description: 'description',
    sku: 'sku',
    quantity: 'quantity',
    price: 'price',
    term: 'term',
    discountNumber: 'discountNumber',
    discountUnit: 'discountUnit',
    total: 'total',
    id: 'id',
} as const;

export const DEFAULT_PRODUCT_NAME = 'Other';

export const TEMPLATE_DATA = [
    <LoadingText
        key='quote-template-row-1'
        width={270}
        height={15}
        color={colors.offWhiteDk}
        isAnimated={false}
    />,
    <LoadingText
        key='quote-template-row-2'
        width={270}
        height={15}
        color={colors.offWhiteDk}
        isAnimated={false}
    />,
    <LoadingText
        key='quote-template-row-3'
        width={270}
        height={15}
        color={colors.offWhiteDk}
        isAnimated={false}
    />,
] as const;

export const TERM_OPTIONS = [
    {value: null, label: 'None'},
    {value: 'MINUTE', label: 'Minute'},
    {value: 'HOUR', label: 'Hour'},
    {value: 'DAY', label: 'Day'},
    {value: 'WEEK', label: 'Week'},
    {value: 'MONTH', label: 'Month'},
    {value: 'QUARTER', label: 'Quarter'},
    {value: 'YEAR', label: 'Year'},
] as const;
